import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledConceptRaceGame = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;

  & * {
    font-size: 1.3vw;
    @media (orientation: portrait) {
      font-size: 2vw;
    }
  }
`;
